import React from "react";


function Footer() {
  return (
    

    <footer className="mainfooter" role="contentinfo">
  <div className="footer-middle">
  <div className="container foot">
   
      <div className="col-md-3 col-sm-6">
        
        <div className="footer-pad">
          
          <ul className="list-unstyled">
            <li><a href="#"></a></li>
          </ul>
        </div>
      </div>
    	
		<div className="col-md-12 copy">
     
			<p className="text-center footerp">&copy; Copyright 2020 - AASH BUILDERS.  All Rights Reserved. <br /> Site by AshikMoosa</p>
      <br/>
      <p className="text-center footerp">All information depicted on the website, including features and designs, is subject to change without notice.</p>
      <br/>
    </div>

  </div>
  </div>
</footer>
  );
}

export default Footer;
